export default "__VITE_ASSET__Cc10ivRb__"